
import Vue from "vue";
import { Pricing, PriceFrequencyType } from "../../models/payment/pricing";
import { AuthService } from "../../services/auth-service";
import { Plan } from "../../utils/payments/plan";
import { formatDistance } from "date-fns";
import nlBeFormat from "date-fns/locale/nl";
import frFormat from "date-fns/locale/fr";
import { Tier } from "../../utils/payments/tiers";
import { PlanModule } from "@/utils/payments/plan-module";
import { PaymentService } from "@/services/payment-service";

export default Vue.extend({
	data() {
		return {
			extraModules: [] as PlanModule[]
		};
	},
	props: {
		pricing: {
			type: Object as () => Pricing,
			required: true
		},
		showPriceType: {
			type: Number as () => PriceFrequencyType,
			required: true
		},
		tier: {
			type: Number,
			required: true
		},
		mostOftenChosen: Boolean,
		currentPlan: {
			type: Object as () => Plan
		},
		hasNoPlan: Boolean
	},
	computed: {
		demoTimeRemaining(): string {
			if (AuthService.wfCompany.ActiveUntil.getTime() < new Date().getTime()) {
				return this.$ct("demo-expired").toString();
			}
			let locale = nlBeFormat;
			if (this.$i18n.locale == "fr") {
				locale = frFormat;
			}
			return this.$ct("time-remaining", {demoTimeRemaining: formatDistance(AuthService.wfCompany.ActiveUntil, new Date(), {locale})}).toString();
		},
		isDemoVersionSelected(): boolean {
			return this.showPriceType == PriceFrequencyType.DEMO;
		},
		price(): number {
			if (this.showPriceType == PriceFrequencyType.PERMANENT) {
				return this.pricing.getPermanentPrice().getPriceOfTier(this.tier);
			}
			if (this.showPriceType == PriceFrequencyType.YEAR) {
				return this.pricing.getDiscountPrice().getPriceOfTier(this.tier);
			}
			return this.pricing.price.getPriceOfTier(this.tier);
		},
		buttonDisabled(): boolean {
			let comp = AuthService.wfCompany;
			if (comp.IsDemo) {
				if (AuthService.wfCompany.isExpired()) {
					return false;
				}
				if (this.showPriceType == PriceFrequencyType.DEMO && this.tier == this.currentPlan.tier) {
					return true;
				}
				return false;
			}
			if (this.hasNoPlan && !AuthService.wfCompany.isPermanentlyActive()){
				if (comp.Tier > this.tier){
					return true;
				}
				return false;
			}
			if (comp.Tier == Tier.FREE && AuthService.wfCompany.isExpired()) {
				return false;
			}
			if (comp.Tier > this.tier){
				return true;
			}
			if (comp.Tier == this.tier){
				return true;
			}
			if (this.differentPaymentFrequencySelected) {
				return false;
			}
			return comp.Tier == this.tier;
		},
		differentPaymentFrequencySelected(): boolean {
			if (!this.currentPlan) {
				return true;
			}
			return this.currentPlan.paymentFrequency != this.showPriceType;
		},
		buttonText(): string {
			let comp = AuthService.wfCompany;
			if (!comp) {
				return "";
			}
			if (this.tier == Tier.ENTERPRISE) {
				return this.$ct("contact-us").toString();
			}
			if (comp.IsDemo) {
				if (this.showPriceType == PriceFrequencyType.DEMO) {
					if (this.tier == this.currentPlan.tier) {
						return this.$ct("actual").toString();
					}
					return this.$ct("try-out-tier").toString();
				}
				return this.$ct("activate").toString();
			}
			if (comp.isExpired()){
				return this.$ct("activate").toString();
			}
			if (comp.Tier > this.tier) {
				return "&nbsp;";
				//return this.$ct("downgrade").toString();
			}
			if (comp.Tier < this.tier) {
				return this.$ct("upgrade").toString();
			}
			return this.$ct("actual").toString();
		},
		pricingSubLabel(): string {
			return this.showPriceType == PriceFrequencyType.PERMANENT ? this.$ct("permanent-price").toString() : this.$ct("price-per-month").toString();
		},
		isEnterprise(): boolean {
			return this.tier == Tier.ENTERPRISE;
		},
		isStarter():boolean {
			return this.tier == Tier.STARTER;
		}
	},
	methods: {
		async order() {
			if (this.tier == Tier.FREE) {
				await PaymentService.activateFreeTier();
				this.$router.push("/");
				setTimeout(()=>{
					location.reload();
				}, 1000);
				return;
			}
			if (this.tier == Tier.ENTERPRISE){
				PaymentService.requestEnterprise();
				this.$router.push("/account/plan-request-successfull");
				return;
			}
			let plan = new Plan();
			plan.tier = this.tier;
			plan.paymentFrequency = this.showPriceType;
			this.$router.push(plan.getBuyRoute());
		},
	},
	i18nEx: {
		componentPrefix: "components.account.pricing"
	}
});
